import { render, staticRenderFns } from "./AssessmentSettingSelectField.vue?vue&type=template&id=3b8f8d7c"
import script from "./AssessmentSettingSelectField.vue?vue&type=script&lang=ts"
export * from "./AssessmentSettingSelectField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports